import { fsumClient } from '@/services/FsumHttpClient';
import type { Certificate } from '@/types/Certificate';

async function getAllCertificates(): Promise<Certificate[]> {
    const certificatesPromise: Promise<Certificate[]> = fsumClient.get('/v1/certificates');

    return certificatesPromise.then(
        (value: Certificate[]) => value,
    );
}

export default {
    getAllCertificates,
};
